import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ConferenciaVolumesTotaisDetalhes, RequisicaoTotalProduto } from 'src/app/@shared/models/confVolume';
import { ConferenciaVolumeService } from 'src/app/services/confVolume/conferencia-volume.service';

@Component({
  selector: 'app-detalhes-lote',
  templateUrl: './detalhes-lote.component.html',
  styleUrls: ['./detalhes-lote.component.scss']
})
export class DetalhesLoteComponent implements OnInit {
  isLoading = false;
  isLoadingDownload: boolean;
  loteId: number;
  detalhesLoteGrid: ConferenciaVolumesTotaisDetalhes[];
  displayedColumns = ['nrt', 'doc', 'nome', 'cep', 'datarecepcao', 'nmanifesto', 'datamanifesto'];
  public paging = { index: 0, size: 5, length: 0 };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<DetalhesLoteComponent>,
    public snackBar: MatSnackBar,
    public route: ActivatedRoute,
    public confVolumeService: ConferenciaVolumeService,
  ) {
    this.loteId = data.loteId;
  }

  ngOnInit() {
    this.getGridDetalhesLote();
  }

  getGridDetalhesLote() {
    this.isLoading = true;
    const obj: RequisicaoTotalProduto = {
      loteID: this.loteId,
      itensPorPagina: this.paging.size,
      paginaAtual: this.paging.index + 1
    }
    this.confVolumeService.confVolumeDetalhes(obj).subscribe(
      (response: ConferenciaVolumesTotaisDetalhes[]) => {
        this.detalhesLoteGrid = response;
        if (response && response.length) {
          this.paging.length = response[0].totalCount;
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.openSnackBar('Erro ao carregar detalhes do lote, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
      },
      () => this.isLoading = false
    );
  }

  // Chamada do Excel;
  base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const binaryLen = binaryString.length;
  let bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

gerarArquivo(data: any, filename: string, type: string) {
  const arrBuffer = this.base64ToArrayBuffer(data)
  const blob = new Blob([arrBuffer], {
    type
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

downloadExcel() {
  this.isLoadingDownload = true;
  const obj: RequisicaoTotalProduto = {
    loteID: this.loteId,
    paginaAtual: this.paging.index + 1,
    itensPorPagina: this.paging.size,
  }
  this.confVolumeService.exportarExcelDetalhesLote(obj).subscribe(
    (response: any) => {
      this.gerarArquivo(
        response.retorno.fileContents,
        response.retorno.fileDownloadName,
        response.retorno.contentType
      )
    },
    (err: HttpErrorResponse) => console.error('erro', err),
    () => this.isLoadingDownload = false
  )
}

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.getGridDetalhesLote();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
